<div class="ibox" ng-show="$ctrl.schedules.length > 0">
  <div class="ibox-content">
    <div class="cf-grid">

      <small>Arraste os cronogramas para reordenar</small>
      <div class="datails-row">
        <div class="datails-col" ng-repeat="summary in $ctrl.summaries">
          <button class="btn btn-white width-100" ng-click="$ctrl.openSummary(summary)">
            Mais detalhes
          </button>
        </div>
      </div>

      <div ui-sortable="$ctrl.sortableOptions" ng-model="$ctrl.schedules">
        <div  class="grid-row" ng-repeat="schedule in $ctrl.schedules track by schedule.id">
          <div class="heading">
            <h3>{{::schedule.gleba.descricao}} <small>{{::schedule.atividade.descricao}} {{(schedule.cultivar || {}).descricao || ''}}  </small></h3>
            <small>{{ schedule.area | number:2}} ha</small>
            <a
              class="text-muted"
              uib-tooltip-template="'views/cronograma_fungicidas/grid-schedule-tooltip.html'"
              tooltip-placement="right"
              tooltip-append-to-body="true"
            >
              <small>
                Detalhes
                <i class="fa fa-info-circle"></i>
              </small>
            </a>
          </div>
          <div class="parameter-row">
            <div class="parameter-col" ng-repeat="parameter in schedule.parameters track by parameter.id">
              <div
                class="parameter"
                ng-class="$ctrl.parameterClasses(parameter)"
                uib-popover-template="'views/cronograma_fungicidas/grid-schedule-parameter-popover.html'"
                popover-append-to-body="true"
                popover-placement="bottom"
                popover-trigger="outsideClick"
                popover-title="Aplicação {{::parameter.numero_aplicacao}}"
              >
                <div class="infos" ng-switch="parameter.status">
                  <div ng-switch-when="will_not_perform">
                    <p><s>Aplicação {{::parameter.numero_aplicacao}}</s></p>
                    <h4><s>{{parameter.data_fim_aplicacao || parameter.data_estimada | date: 'dd/MM'}}</s></h4>
                  </div>
                  <div ng-switch-default>
                    <p>
                      Aplicação {{::parameter.numero_aplicacao}}
                      <i
                        class="fa fa-exclamation-triangle"
                        ng-if="$ctrl.wasAppliedLate(parameter)"
                        uib-tooltip="Aplicada após a data estimada"
                        tooltip-append-to-body="true"
                        tooltip-placement="right"
                      ></i>
                    </p>
                    <h4>
                      {{parameter.data_fim_aplicacao || parameter.data_estimada | date: 'dd/MM'}}
                    </h4>
                    <h4 ng-if="!!parameter.dias_apos_aplicado">
                      DAA: {{parameter.dias_apos_aplicado}}
                    </h4>
                    <span>
                      <h4>Pos. Ciclo: {{$ctrl.diffDays(
                                          schedule.data_emergencia,
                                          parameter.data_fim_aplicacao || parameter.data_estimada
                                        )}}</h4>
                    </span>
                  </div>
                </div>
                <div class="more">
                  <i class="fa fa-plus-circle"></i>
                </div>
              </div>
            </div>
          </div>
          <div class="actions">
            <a
              class="btn btn-link btn-xs"
              uib-tooltip="Editar cronograma"
              tooltip-placement="left"
              tooltip-append-to-body="true"
              ng-click="$ctrl.editSchedule(schedule)"
            >
              <i class="fa fa-edit"></i>
            </a>
            <a
              class="btn btn-link btn-xs text-info"
              uib-tooltip="Duplicar para outras talhões"
              tooltip-placement="left"
              tooltip-append-to-body="true"
              ng-click="$ctrl.duplicateSchedule(schedule)"
            >
              <i class="fa fa-clone"></i>
            </a>
            <a
              class="btn btn-link btn-xs text-danger"
              uib-tooltip="Apagar cronograma"
              tooltip-placement="left"
              tooltip-append-to-body="true"
              ng-click="$ctrl.deleteSchedule(schedule)"
            >
              <i class="fa fa-trash"></i>
            </a>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>

<script type="text/ng-template" id="modal-report-demanda-uso.html">
  <div class="modal-header">
    <h3 class="modal-title" id="modal-title">Demanda de uso de Insumos</h3>
  </div>

  <div class="modal-body" id="modal-body">
    <div class="form-group">
      <ui-select class="modal-select" multiple ng-model="params.propriedades" theme="bootstrap" id="propriedades" name="propriedades">
        <ui-select-match allow-clear="true" placeholder="Propriedade(s)">{{$item.descricao | capitalize}}</ui-select-match>
        <ui-select-choices repeat="propriedade in allPropriedades | orderBy: 'descricao' | filter: $select.search">
          <span  class="form-group" ng-bind-html="propriedade.descricao | capitalize | highlight: $select.search"></span>
        </ui-select-choices>
      </ui-select>

      <label class="control-label">Período</label>
      <input date-range-picker class="form-control date-picker" type="text" ng-model="params.period" options="opts" readonly />
    </div>

    <div class="only-print" id="demanda-uso-insumos" ng-include="'views/demandausoinsumos.html'"></div>
  </div>
  <div class="modal-footer">
    <button class="btn btn-primary" type="button" ng-disabled="loading" ng-click="get()">
      OK
      <span ng-if="loading"><i class="fa fa-spinner fa-spin"></i></span>
    </button>
    <button class="btn btn-warning" type="button" ng-disabled="loading" ng-click="close()">Cancelar</button>
    <button ng-print print-element-id="demanda-uso-insumos" class="hide" id="btn-print"></button>
  </div>
</script>
